import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { userRedirectResolver } from '../resolve/user.resolver';

@Injectable()
export class InvalidAccountGuard {
  constructor(
    private _router: Router,
    private _globalService: GlobalService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this._globalService.user || !this._globalService.user.isActive) return true;

    const redirectTo = userRedirectResolver(null, null);
    this._router.navigate([redirectTo]);
  }
}
